import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import { tableActionButtonStyles } from './tableActionButtonStyles';

const TableActionButton = ({ icon, title = '', onClick = () => {}, style }) => {
  const styles = tableActionButtonStyles();

  const handleClick = (e) => {
    onClick();
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Tooltip title={title}>
      <IconButton className={style || styles.buttonContainer} onClick={handleClick}>
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default TableActionButton;
